import {
  Injectable
} from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  RateTypeWms
} from '../models';

import {
  getAuthHeaders
} from '../app/app.utils';

import {
  _WMS_URL
} from '../app/app.const';

@Injectable()
export class RateTypeService {
  public authToken: string;
  
  constructor(
    private http: HttpClient
  ) {}

  public getById(
    _id: string
  ): Promise<RateTypeWms> {
    return (
      <any>(
        this.http
            .get(
              `${_WMS_URL}api/rates/${_id}`,
              getAuthHeaders(
                this.authToken
              )
            )
            .toPromise()
      )
    );
  }

  public getByPartnerCode(
    partnerCode: string
  ): Promise<RateTypeWms> {
    return (
      <any>(
        this.http
            .get(
              `${_WMS_URL}api/rates/${partnerCode}`,
              getAuthHeaders(
                this.authToken
              )
            )
            .toPromise()
      )
    );
  }
  
  public getAll(): (
    Promise<RateTypeWms[]>
  ) {
    return (
      <any>(
        this.http
            .get(
              `${_WMS_URL}api/rates`,
              getAuthHeaders(
                this.authToken
              )
            )
            .toPromise()
      )
    );
  }
}